import moment from "moment";

import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  err: null,
  initialValues: {}
};

const getVehicleDataStart = (state) => ({
  ...state,
  loading: true
});

const getVehicleDataSuccess = (state, action) => {
  let initialValues = {
    vin: action.data?.vehicleDetails?.vin,
    source: action.data?.source,
    appointmentId: action.data?.appointmentId
  };

  const {
    amount,
    bank,
    id,
    paidDate,
    paymentAdvice,
    remittanceAdvice,
    paymentType = "CAR_PURCHASE",
    referenceNo,
    paymentSubType
  } = action.data;

  initialValues = {
    ...initialValues,
    ...state.initialValues,
    amount,
    bank,
    paymentType,
    paymentAdvice: [paymentAdvice],
    remittanceAdvice,
    paidDate: paidDate ? moment(paidDate) : null,
    referenceNo,
    id,
    paymentSubType
  };

  return {
    ...state,
    loading: false,
    initialValues
  };
};

const getVehicleDataFail = (state) => ({
  ...state,
  loading: false
});

const submitPaymentFormStart = (state) => ({
  ...state,
  loading: true
});

const submitPaymentFormSuccess = (state) => ({
  ...state,
  loading: false,
  err: null
});

const submitPaymentFormFail = (state, action) => ({
  ...state,
  loading: false,
  err: action.err.status
});

const resetFormData = (state) => ({
  ...state,
  initialValues: {}
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_FINANCE_VEHICLE_DATA_START:
      return getVehicleDataStart(state, action);
    case actionTypes.GET_FINANCE_VEHICLE_DATA_SUCCESS:
      return getVehicleDataSuccess(state, action);
    case actionTypes.GET_FINANCE_VEHICLE_DATA_FAIL:
      return getVehicleDataFail(state, action);

    case actionTypes.SUBMIT_FINANCE_PAYMENT_START:
      return submitPaymentFormStart(state, action);
    case actionTypes.SUBMIT_FINANCE_PAYMENT_SUCCESS:
      return submitPaymentFormSuccess(state, action);
    case actionTypes.SUBMIT_FINANCE_PAYMENT_FAIL:
      return submitPaymentFormFail(state, action);

    case actionTypes.RESET_FINANCE_FORM_DATA:
      return resetFormData(state, action);

    default:
      return state;
  }
};

export default reducer;
